import { useInfiniteQuery } from "react-query";
import useNetworkHeaders from "../../hooks/useNetworkHeaders";
import { useMemo } from "react";
import { GetCrmListFieldDefinitionsParamsType, getCrmRequests } from "../queries/getCrmRequests";

export function useInfiniteCrmRequests(params: GetCrmListFieldDefinitionsParamsType) {
  const networkHeaders = useNetworkHeaders();
  const {
    data,
    isLoading: isCrmRequestsLoading,
    isFetching: isCrmRequestsFetching,
    fetchMore: fetchMoreCrmRequests,
    canFetchMore: canFetchMoreCrmRequests,
    error: crmRequestsError,
    clear: clearCrmRequests,
    remove: removeCrmRequests,
    refetch: refetchCrmRequests,
  } = useInfiniteQuery(buildCrmRequestsQueryKey(params), getCrmRequests(networkHeaders), {
    queryFnParamsFilter(args) {
      return [args[1]];
    },
    getFetchMore: (lastPage) => lastPage.data.at(-1)?.cursor,
    keepPreviousData: true,
  });

  const crmRequests = useMemo(() => data?.flatMap(({ data }) => data) ?? [], [data]);
  const lastPage = data?.at(-1);

  return {
    crmRequestsTotal: lastPage?.total ?? 0,
    crmRequests,
    isCrmRequestsLoading,
    isCrmRequestsFetching,
    fetchMoreCrmRequests,
    canFetchMoreCrmRequests,
    crmRequestsError,
    clearCrmRequests,
    removeCrmRequests,
    refetchCrmRequests,
  };
}

export function buildCrmRequestsQueryKey(params?: GetCrmListFieldDefinitionsParamsType) {
  if (!params) {
    return "useInfiniteCrmRequests";
  }
  return ["useInfiniteCrmRequests", params];
}
